import React from 'react';
import { HeroSection } from '../components/home/HeroSection';
import { Statistics } from '../components/Statistics';
import { IndustriesServed } from '../components/home/IndustriesServed';
import { WhatWeOffer } from '../components/home/WhatWeOffer';
import { KnowISDE } from '../components/home/KnowISDE';
import { EmpowerSuccess } from '../components/home/EmpowerSuccess';
import { PopularCourses } from '../components/home/PopularCourses';
import { Testimonials } from '../components/Testimonials';
import { CustomerLogoCarousel } from '../components/CustomerLogoCarousel';
import { FeaturedGallery } from '../components/home/FeaturedGallery';
import { SEO } from '../components/SEO';
import { StrategicVision } from '../components/StrategicVision';

export const Home = () => {
  return (
    <div className="pt-20">
      <SEO
        title="ISDE Academy - Professional Training & Development Since 2015"
        description="Transform your career with ISDE Academy's professional training programs. Expert-led courses in technology, business, and professional development. Join 10,000+ successful professionals."
        keywords="ISDE Academy, professional training, corporate training, online courses, certification programs, skill development, professional development, training institute"
        type="website"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "EducationalOrganization",
          "name": "ISDE Academy",
          "description": "Professional Training & Development Institute",
          "url": "https://isde.academy",
          "logo": "https://isde.academy/logo.png",
          "foundingDate": "2015",
          "address": {
            "@type": "PostalAddress",
            "addressCountry": "IN"
          },
          "contactPoint": {
            "@type": "ContactPoint",
            "contactType": "Customer Service",
            "availableLanguage": "English"
          },
          "sameAs": [
            "https://www.linkedin.com/company/isde-academy",
            "https://twitter.com/isdeacademy"
          ]
        }}
      />
      <HeroSection />
      <Statistics />
      <CustomerLogoCarousel />
      <IndustriesServed />
      <StrategicVision />
      <WhatWeOffer />
      <KnowISDE />
      <PopularCourses />
      <FeaturedGallery />
      <EmpowerSuccess />
      <Testimonials />
    </div>
  );
};
